import { pick } from 'lodash';
import React from 'react';
import { useSessionStorage } from './use-session-stoage';
export function useStoredCentre(centre) {
  const [data, setData] = useSessionStorage('sg_centre');
  const setStoredCentre = React.useCallback(data => {
    if (data === null) {
      setData(null);
    } else {
      setData(pick(data, ['title', 'slug']));
    }
  }, [setData]);
  React.useEffect(() => {
    if (centre !== undefined) {
      setStoredCentre(centre);
    }
  }, [centre, setStoredCentre]);
  return [data, setStoredCentre];
}